import gql from "graphql-tag";

// Staff props
const RotaStaffProps = gql`
    fragment RotaStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        email
        mobile
        designation {
            name
        }
        type {
            id
            name
        }
        designation {
            id
            name
        }
        department {
            id
            name
        }
        image
    }
`;
const ROTA_PROPS = gql`
    fragment ROTA_PROPS on Rota {
        id
        period {
            id
            name
        }
        date
        end_date
        author {
            ...RotaStaffProps
        }
        assignee {
            attended
            staff {
                ...RotaStaffProps
            }
        }
    }
    ${RotaStaffProps}
`;
const KeyProps = gql`
    fragment KeyProps on StaffOnRotaDutyKey {
        period {
            id
            name
        }
        date {
            end
            start
        }
    }
`;

const LIST = gql`
    query GetStaffOnRotaDuty {
        GetStaffOnRotaDuty {
            docs {
                key {
                    ...KeyProps
                }
                assignees {
                    staff {
                        ...RotaStaffProps
                    }
                }
            }
        }
    }
    ${KeyProps}
    ${RotaStaffProps}
`;

const STAFF_LIST = gql`
    query GetStaffListPaginate($page: Int!, $limit: Int!) {
        GetStaffList(page: $page, limit: $limit) {
            docs {
                ...RotaStaffProps
            }
        }
    }
    ${RotaStaffProps}
`;

const PERIOD_LIST = gql`
    query GetRotaDutyPeroids {
        GetRotaDutyPeroids {
            docs {
                id
                name
            }
        }
    }
`;

const CREATE = gql`
    mutation CreateRota($model: RotaInput!) {
        CreateRota(model: $model) {
            message
            doc {
                ...ROTA_PROPS
            }
        }
    }
    ${ROTA_PROPS}
`;

const GET_ROTAS = gql`
    query GetRotas($page: Int!, $limit: Int!) {
        GetRotas(page: $page, limit: $limit) {
            page
            limit
            totalDocs
            totalPages
            nextPage
            prevPage
            message
            docs {
                ...ROTA_PROPS
            }
        }
    }
    ${RotaStaffProps}
    ${ROTA_PROPS}
`;

export { LIST, STAFF_LIST, PERIOD_LIST, CREATE, GET_ROTAS };
